module.exports = __webpack_public_path__ + "img/ay.0cfa2293.png";